import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BitmapText, Container } from '@pixi/react';
import { useMemo } from 'react';
import { useFadeOutWithContainerRefCallback } from '../../../../hooks/fadeOutAnimationHook';
import { ALL_BET_POT_ACTION_LABELS } from '../../../../types/pokerTypes';
import { getBitmapTextDimensions } from '../../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../../utils/utils';
const LETTER_SPACING = 1;
export const BetPotLabel = ({ seatIndex, betPotActionType, betPotChipsBetThisRound, betPotBetSequenceNumber }) => {
    const [containerRef, isDoneFadingOut] = useFadeOutWithContainerRefCallback(2500, 1000, betPotBetSequenceNumber);
    const label = ALL_BET_POT_ACTION_LABELS[betPotActionType];
    const labelDimensions = useMemo(() => getBitmapTextDimensions(label, 'pot-label', { letterSpacing: LETTER_SPACING }), [label]);
    return (_jsx(Container, { ref: containerRef, children: !isDoneFadingOut && (_jsx(BitmapText, { "pixi-data": isTestEnvironment() ? { type: 'bet-pot-label', seatIndex } : null, style: { fontName: 'pot-label', letterSpacing: LETTER_SPACING }, text: label, x: -Math.round(labelDimensions.w / 2), y: betPotChipsBetThisRound
                ? -Math.round(labelDimensions.h / 2) - 7 // if an amount is to be shown, display the label above center to make room
                : -Math.round(labelDimensions.h / 2) // no label, center
         })) }));
};
